import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCvyI6hKTmpcdbVP-qs2AEjFqdBplyNI-I",
  authDomain: "braco-444315.firebaseapp.com",
  databaseURL: "https://braco-444315-default-rtdb.firebaseio.com",
  projectId: "braco-444315",
  storageBucket: "braco-444315.firebasestorage.app",
  messagingSenderId: "82201853472",
  appId: "1:82201853472:web:643d4a058761f247324645"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
